export const APPOINTMENT_URL = process.env.REACT_APP_CONTACTS_API_URL;
export const CONSULTING_URL = process.env.REACT_APP_CONTACTS_API_URL;
